import { Component, Host, OnInit } from '@angular/core';
import { ModalComponent } from '../modal.component';

@Component({
  standalone: false,
  selector: 'modal-body',
  templateUrl: './modal-body.component.html',
})
export class ModalBodyComponent implements OnInit {
  constructor(@Host() public modal: ModalComponent) {}

  ngOnInit() {}
}
